import { useQuery } from '@tanstack/react-query'

import { getMonthlyCardBill } from '@src/api'
import { DefaultApiGetMonthlyCardBillRequest } from '@src/api/generated/user-api'
import { REACT_QUERY_CACHE_KEYS } from '@src/consts'
import { useAxios } from '@src/hooks'

export const useFetchMonthlyCardBill = (
  params: DefaultApiGetMonthlyCardBillRequest,
  enabled = true
) => {
  const { axiosInstance } = useAxios()
  const { organizationId, ...queryParams } = params

  return useQuery({
    enabled: !!params.organizationId && enabled,
    queryFn: () => getMonthlyCardBill(axiosInstance, params),
    queryKey: [
      REACT_QUERY_CACHE_KEYS.GET_MONTHLY_CARD_BILL,
      organizationId,
      queryParams,
    ],
  })
}
